import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-setting-room',
    templateUrl: './setting-room.component.html',
    styleUrls: ['./setting-room.component.css'],
})
export class SettingRoomComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication-room/setting-room/setting-room.component.ts